import React from "react";
import { Card, CardMedia, CardContent, Typography } from "@mui/material";
import { icons } from "../../../../assets/icons/icons";

interface CardCheckInProps {
  onClick: () => void; // Add onClick as a prop
}

const CardCheckIn: React.FC<CardCheckInProps> = ({ onClick }) => {
  return (
    <Card
      sx={{
        maxWidth: 225,
        minWidth: 225,
        display: "flex",
        flexDirection: "column",
        borderRadius: 2,
        boxShadow: 3,
        padding: 4,
      }}
      onClick={onClick} 
    >
      <CardMedia
        component="img"
        height="100"
        image={icons.check_in_record}
        alt="Image description"
        sx={{ objectFit: "cover", borderBottom: "1px solid #ddd" }}
      />
      <CardContent
        sx={{
          padding: 2,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <Typography variant="body2" color="text.secondary" align="center">
          กดเพื่อบันทึกเวลา เข้า-ออกงาน
        </Typography>
      </CardContent>
    </Card>
  );
};

export default CardCheckIn;
